import { IPhoneNumber } from 'store/directory/directory.state'

export const getFirstPhoneNumber = (phoneNumbers: IPhoneNumber[]) =>
    phoneNumbers?.[0].value || ''
